<template>
  <div>
    <!--搜索栏-->
    <searchBar
      :search-form="searchForm"
      newsTypeId
      publish-status
      date-start
      date-end
      btn-add
      :newsOptionType="optionType"
      @handleAdd="handleAdd"
      @handleSearch="getData"
    ></searchBar>

    <!--表格-->
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
      ></el-table-column>
      <el-table-column label="封面" align="center" width="140">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 120px;"
            :src="serverUrl + scope.row.cover"
            :preview-src-list="getImgPreviewList(scope.row.cover)"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        :prop="index"
        align="center"
      ></el-table-column>

      <el-table-column fixed="right" label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button
            @click="showDialogContent(scope.row)"
            type="text"
            size="mini"
          >
            详情
          </el-button>
          <el-button @click="handleEdit(scope.row)" type="text" size="mini">
            编辑
          </el-button>
          <!--          <el-button @click="handlePublish(scope.row,(scope.row.status===2||scope.row.status===4)?3:4)"-->
          <!--                     type="text"-->
          <!--                     v-if="scope.row.status!==1"-->
          <!--                     size="mini">{{ (scope.row.status === 2 || scope.row.status === 4) ? '发布' : '屏蔽' }}-->
          <!--          </el-button>-->
          <el-button
            @click="handleDelete(scope.row)"
            type="text"
            style="color:red"
            size="mini"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[4, 10, 20, 30]"
        :page-size="size"
        layout=" prev, pager, next, jumper, sizes"
        :total="totalElements"
      ></el-pagination>
    </div>

    <!--新增Dialog-->
    <el-dialog
      title="添加新闻"
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        label-suffix="："
        label-position="right"
        :status-icon="true"
      >
        <el-form-item label="标题" prop="title" label-width="100px">
          <el-input
            v-model="form.title"
            size="medium"
            placeholder="标题"
          ></el-input>
        </el-form-item>

        <el-form-item label="新闻类型" prop="type" label-width="100px">
          <el-cascader
            style="width: 100%;"
            size="medium"
            :props="props"
            @change="handleCascader"
            v-model="form.type"
            :options="optionType"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="封面图"
          style="text-align: left"
          prop="cover"
          label-width="100px"
        >
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :before-upload="coverDefault"
            accept="image/*"
          >
            <img
              class="avatar"
              v-if="form.cover"
              :src="serverUrl + form.cover"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item
          label="视频"
          style="text-align: left"
          prop="videos"
          label-width="100px"
        >
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :before-upload="videoDefault"
            :auto-upload="true"
          >
            <video width="30%" v-if="form.video" controls="controls">
              <source :src="serverUrl + form.video" type="video/mp4" />
            </video>
            <i v-else class="el-icon-video-camera avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="内容" label-width="100px" prop="content">
          <quill-editor
            style="text-align: left;"
            v-model="form.content"
            class="ql-editor"
            ref="myQuillEditor"
            :options="editorOption"
            @focus="onEditorFocus($event)"
            @blur="onEditorBlur($event)"
            @change="onEditorChange($event)"
          ></quill-editor>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm(1)">保存草稿</el-button>
        <el-button type="primary" @click="dialogConfirm(2)">提交审核</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog
      title="详情"
      :close-on-click-modal="false"
      :visible.sync="dialogContentVisible"
    >
      <Details :detail="dialogContent" :type="'news'"></Details>
    </el-dialog>
    <!--预览图dialog-->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import Details from "@/components/details/index"
import Axios from "axios"
import apiUrl from "@/assets/http/apiUrl"
import { quillEditor } from "vue-quill-editor"
import "quill/dist/quill.snow.css"
import { quillRedefine } from "vue-quill-editor-upload"

export default {
  name: "newsManager",
  components: {
    quillEditor,
    quillRedefine,
    Details,
  },
  data() {
    let Self = this

    // 表单验证
    let validate = (rule, value, callback) => {
      if (!!value) {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("数据填写不完整"))
      }
    }

    return {
      // 页面初始数据
      totalElements: 10,
      currentElements: 10,
      totalPages: 1,
      size: 4,
      page: 1,

      serverUrl: apiUrl.ServerUrl,

      // 搜索栏初始化
      searchForm: {
        title: "",
        publishStatus: "",
        newsTypeId: "",
        type: "",
        start: "",
        end: "",
      },

      // 表头初始化
      tableHeader: {
        title: "标题",
        typeName: "类型",
        auditorName: "作者",
        publishAt: "发布时间",
        readTimes: "阅读量",
        statusName: "状态",
      },

      // 表格数据
      tableData: [],

      // dialog可见性
      dialogFormVisible: false,
      dialogUploadVisible: false,
      dialogContentVisible: false,
      activityContent: "",

      // 上传文件列表
      file: "",
      // 控制详情弹窗
      dialogContentVisible: false,
      dialogContent: "",

      // 新增表单
      form: {
        uid: "",
        title: "",
        content: "",
        type: "",
        cover: "",
        video: "",
        status: "",
        isNpc: true,
      },

      // 表单验证规则
      rules: {
        title: {
          required: true,
          trigger: "blur",
          message: "请输入标题",
        },
        type: {
          required: true,
          trigger: "blur",
          message: "请选择新闻类型",
        },
        content: {
          required: true,
          trigger: "blur",
          message: "请输入内容",
        },
        // videos:{
        //   required: true,
        //   trigger: "blur",
        //   message: "请上传视频",
        // }
      },

      // 头像上传初始化
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,

      // 编辑器配置
      editorOption: {
        placeholder: "请详细填写活动内容",
        modules: {
          toolbar: [
            "bold",
            "italic",
            "underline",
            "strike",
            "align",
            "link",
            "image",
          ],
        },
      },

      // 当前选择的活动
      currentActityUid: "",

      // 级联选择器配置
      props: {
        value: "uid",
        label: "name",
      },
      optionType: [
        {
          name: "全部",
          uid: "",
        },
      ],
      //上传图片
      serverUrl: apiUrl.ServerUrl,
      uploadAvatarServer: apiUrl.UploadFile,
      coverImgUrl: "",
      videoUrl: "",
    }
  },
  methods: {
    handleCoverSuccess(res) {
      console.log(res)
      this.form.cover = res
      this.coverImgUrl = apiUrl.ServerUrl + this.form.cover
    },
    // 上传视频
    handleVideoSuccess(res) {
      this.form.video = res
      this.videoUrl = apiUrl.ServerUrl + this.form.video
      console.log("视频文件===", this.videoUrl)
    },
    beforeVideoUpload(file) {},
    //上传图片之前的回调
    beforeAvatarUpload(file) {
      const isJPGorPNG =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png"
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPGorPNG) {
        this.$message.error("上传图片只能是 JPG或PNG 格式!")
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!")
        alert("上传图片大小不能超过 2MB!")
      }
      return isJPGorPNG && isLt2M
    },
    /*图片预览
     * */
    getImgPreviewList(url) {
      let arr = new Array(this.serverUrl + url)
      return arr
    },

    /*请求数据
     * */
    getData() {
      this.request({
        url: "/manager/news/findByCondition",
        method: "get",
        params: {
          page: this.page,
          size: this.size,
          title: this.searchForm.title,
          status: this.searchForm.publishStatus,
          newsType: this.searchForm.newsTypeId,
          startDate: this.searchForm.startDate,
          endDate: this.searchForm.endDate,
        },
      })
        .then(res => {
          this.size = res.data.data.size
          this.page = res.data.data.page
          this.totalElements = Number(res.data.data.totalElements)
          this.totalPages = res.data.data.totalPages
          this.currentElements = res.data.data.currentElements
          this.tableData = res.data.data.content
          if (res.data.data.content) {
            this.tableData.forEach(item => {
              item.content = item.content.replace(
                /\<img/gi,
                '<img style="width:100%"'
              )
            })
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*获取新闻类型
     * */
    getType() {
      this.request({
        url: "/manager/newsType/findAll",
        method: "get",
        params: {},
      })
        .then(res => {
          this.optionType = res.data.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*更改单页数据数量
     * */
    handleSizeChange(size) {
      this.size = size
      this.getData()
    },

    /*页码跳转
     * */
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },

    /*启用/禁用
     * */
    handleEnabled(rowData) {
      let status = rowData.status === 1 ? 2 : 1
      this.request({
        url: "/manager/activity/updateStatus",
        data: {
          uid: rowData.uid,
          status: status,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*审核参加人员
     * */
    handleAudit(rowData) {
      this.currentActityUid = rowData.uid
      this.getVolunteers(this.currentActityUid)
    },

    /*编辑
     * */
    handleEdit(rowData) {
      this.form = {
        ...rowData,
      }
      if (rowData.cover) {
        this.coverImgUrl = apiUrl.ServerUrl + rowData.cover
      } else {
        this.coverImgUrl = ""
        this.form.cover = ""
      }
      if (rowData.video) {
        this.videoUrl = apiUrl.ServerUrl + rowData.video
      } else {
        this.videoUrl = ""
        this.form.video = ""
      }
      this.dialogFormVisible = true
    },

    /*发布新闻
     * status
     *   3 发布
     *   4 屏蔽*/
    handlePublish(rowData, type) {
      let text = type === 2 || type === 4 ? "屏蔽" : "发布"
      this.$confirm("确认" + text + "?")
        .then(() => {
          this.request({
            url: "/manager/news/releaseOrShield",
            params: {
              uid: rowData.uid,
              status: type,
            },
            method: "post",
          })
            .then(res => {
              this.$message.success(text + "成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },

    /*添加操作
     * */
    handleAdd() {
      this.dialogFormVisible = true
    },

    /*删除
     * */
    handleDelete(rowData) {
      this.$confirm("确认删除?")
        .then(() => {
          this.request({
            url: "/manager/news/delete",
            params: {
              uid: rowData.uid,
            },
            method: "DELETE",
          })
            .then(res => {
              this.$message.success("删除成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },

    /*dialog提交
     * type:
     *   0 草稿
     *   1 待发布
     * */
    dialogConfirm(type) {
      this.$refs.form.validate(valid => {
        // if (type === 1) {
        //   valid = true
        // }
        if (valid) {
          this.request({
            url: "/manager/news/addOrUpdate",
            // data: this.form,
            data: {
              uid: this.form.uid,
              title: this.form.title,
              content: this.form.content,
              type: this.form.type,
              cover: this.form.cover,
              videos: this.form.videos,
              status: type,
              // isNpc: this.form.isNpc,
            },
            method: "post",
          })
            .then(res => {
              if (res.data.status === "BAD_REQUEST") {
                this.$message.error(res.data.message)
              } else {
                this.dialogFormVisible = false
                this.getData()
                this.form = {
                  uid: "",
                  title: "",
                  content: "",
                  type: "",
                  cover: "",
                  video: "",
                  status: "",
                  isNpc: true,
                }
              }
            })
            .catch(err => {
              this.$message.warning(err.message)
            })
        }
      })
    },

    /*dialog取消
     * */
    dialogCancel() {
      this.form = {
        uid: "",
        title: "",
        content: "",
        type: "",
        cover: "",
        status: "",
        isNpc: true,
      }
      this.center = {}
      this.dialogFormVisible = false
    },

    //上传封面图
    coverDefault(e) {
      let tmpFile = new FormData()
      tmpFile.append("file", e)
      tmpFile.append("folder", "notify")
      Axios.post(apiUrl.server + "/manager/upload/uploadFile", tmpFile)
        .then(res => {
          // console.log(res.data)
          this.form.cover = res.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    videoDefault(e) {
      let tmpFile = new FormData()
      tmpFile.append("file", e)
      tmpFile.append("folder", "notify")
      Axios.post(apiUrl.server + "/manager/upload/uploadFile", tmpFile)
        .then(res => {
          // console.log(res.data)
          this.form.video = res.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    uploadCancel() {
      this.dialogUploadVisible = false
      this.form = {}
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    // 准备富文本编辑器
    onEditorReady(editor) {},
    // 富文本编辑器 失去焦点事件
    onEditorBlur(editor) {},
    // 富文本编辑器 获得焦点事件
    onEditorFocus(editor) {},
    // 富文本编辑器 内容改变事件
    onEditorChange(editor) {
      this.form.conditions = editor.html
    },

    /*级联选择器
     * */
    // 处理小组/街道uid
    handleCascader(uids) {
      if (uids) {
        this.form.type = uids[0]
      }
    },

    // showActivityContent(content) {
    //   this.dialogContentVisible = true
    //   this.activityContent = content
    // },
    // 查看详情
    showDialogContent(rowData) {
      this.dialogContentVisible = true
      this.dialogContent = rowData
    },
  },
  mounted() {
    this.getData()
    this.getType()
  },
  beforeDestroy() {
    this.editor = null
    delete this.editor
  },
  created() {
    let token = localStorage.getItem("token")
    this.editorOption = quillRedefine({
      // 图片上传的设置
      uploadConfig: {
        action: apiUrl.server + "/manager/upload/uploadHighPic", // 必填参数 图片上传地址
        // 必选参数  res是一个函数，函数接收的response为上传成功时服务器返回的数据
        // 你必须把返回的数据中所包含的图片地址 return 回去
        name: "file",
        res: respnse => {
          console.log(apiUrl.server.split("/api")[0] + respnse.data)
          return apiUrl.server.split("/api")[0] + respnse.data // 这里切记要return回你的图片地址
        },
        header: (xhr, formData) => {
          xhr.setRequestHeader("Authorization", token)
          formData.append("uid", this.form.uid)
        },
      },
    })
  },
}
</script>

<style scoped>
.bm-view {
  width: 100%;
  height: 300px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 200px;
  height: 150px;
  object-fit: cover;
  display: block;
}
</style>
